import React, { useState } from "react";

const UnknownComponent = () => {
  return (
    <div className="utility-page-wrap _404">
      <div className="utility-page-content">
        <h1 className="_404-heading">404</h1>
        <div className="paragraph-20px">
          The page you are looking for doesn&#x27;t exist or has been moved
        </div>
      </div>
    </div>
  );
};

export default UnknownComponent;
